import React from 'react';
import Button from '../UI/Buttons/Button';
import { getRedirection, sendEvent } from '../../utils';
import BackroundImageElement from '../UI/Image/BackgroundImageElement';
import StaticImage from '../UI/Image/StaticImage';
import { IContentGlobalLegal } from '../../types/content';

interface IHeroBlockProps {
  imageName: string;
  mobileImage: string;
  tabletImage?: string;
  title: string;
  Tag?: any | string;
  subtitle: string;
  cta?: {
    productId?: string;
    country_code?: string;
    text?: string;
    tracking?: string;
    redirectionType?: string;
    redirectionValue?: string;
  };
  legal?: IContentGlobalLegal;
}

const isClickingBanner = (event: any) =>
  event &&
  event.target &&
  event.target.classList &&
  event.target.classList[0] &&
  event.target.classList[0].includes('hero__block__content');

const HeroBlock: React.FC<IHeroBlockProps> = ({
  imageName,
  mobileImage,
  tabletImage,
  title,
  subtitle,
  cta,
  legal,
  Tag = 'h2'
}) => {
  const handleRedirection = (event: any) => {
    if (isClickingBanner(event)) {
      sendEvent(cta.tracking);

      window.location.href = getRedirection(
        cta.redirectionType,
        cta.redirectionValue,
        cta.country_code
      );
    }
  };

  return (
    <BackroundImageElement
      imageName={imageName}
      classNames={['hero__block']}
      onClick={handleRedirection}
    >
      {tabletImage && (
        <StaticImage
          classNames={['hero__block__tablet-img']}
          imageName={tabletImage}
          altText=""
        />
      )}
      <StaticImage
        classNames={['hero__block__mobile-img']}
        imageName={mobileImage}
        altText=""
      />
      <div className="hero__block__content">
        <Tag className="hero__block__content__title">{title}</Tag>
        <div className="hero__block__content__subtitle">{subtitle}</div>
        <div className="hero__block__content__cta">
          <Button
            redirection={{
              type: cta.redirectionType as 'category' | 'custom' | 'product',
              value: cta.redirectionValue
            }}
            countryCode={cta.country_code}
            type="shop"
            content={cta.text}
            handleClick={() => sendEvent(cta.tracking)}
          />
        </div>
        {legal && (
          <Button
            type="secondary"
            Tag="a"
            classes="hero__legal"
            content={legal.text}
            noButtonClasses
            countryCode={cta.country_code}
            redirection={{
              type: legal.redirectionType as 'custom' | 'product' | 'category',
              value: legal.redirectionValue
            }}
            handleClick={() => sendEvent(legal.tracking)}
          />
        )}
      </div>
    </BackroundImageElement>
  );
};

export default HeroBlock;
